module.exports = __webpack_public_path__ + "static/img/p.403d206c.png";